export default {
  addOns: 'ส่วนเสริม',
  all: 'ทั้งหมด',
  browse: 'เรียกดู',
  buyTickets: 'ซื้อตั๋ว',
  countSelected: 'เลือก {{count}} รายการ',
  joinWaitlist: 'เข้าร่วมรายการรอ',
  joining: 'กำลังเข้าร่วม',
  salesEnded: 'สิ้นสุดการขายแล้ว',
  schedule: 'ตารางเวลา',
  soldOut: 'ขายหมดแล้ว',
  tickets: 'ตั๋ว',
  noDatesAvailable: 'ไม่มีวันที่ว่าง',
  seeMoreDates: 'ดูวันอื่นเพิ่มเติม',
  about: 'เกี่ยวกับ',
  agenda: 'กำหนดการ',
  menu: 'เมนู',
  included: 'รวมอยู่',
  viewMore: 'ดูเพิ่มเติม',
  viewLess: 'ดูน้อยลง',
  location: 'สถานที่',
  time: 'เวลา',
  at: 'เวลา',
  noTimesAvailableOnThisDateFotThisPartySize:
    'ไม่มีเวลาว่างในวันนี้สำหรับจำนวนผู้เข้าร่วมนี้',
  availableTimes: 'เวลาที่ว่าง',
  waitlist: 'รายการรอ',
  continue: 'ดำเนินการต่อ',
  ticketsAreNoLongerAvailable: 'ตั๋วไม่มีจำหน่ายแล้ว',
  checkOutOutOtherExperiences: 'ดูประสบการณ์อื่น ๆ ของเรา!',
  viewExperiences: 'ดูประสบการณ์',
  from: 'เริ่มต้น',
  cancellationPolicy: 'นโยบายการยกเลิก',
  rsvp: 'RSVP',
  nights: 'คืน',
  request: 'คำขอ',
  arrival: 'เข้าพัก',
  departure: 'ออก',
};
